import React, { useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

function TipPortal({ anchorRect, text }) {
  if (!anchorRect || !text) return null;
  return createPortal(
    <span
      className="process-sidebar-tooltip-portal"
      style={{
        top: anchorRect.top + anchorRect.height / 2,
        left: anchorRect.right + 10,
      }}
      role="tooltip"
    >
      {text}
    </span>,
    document.body
  );
}

/**
 * Alça na borda direita da sidebar (recolher/expandir), no estilo do resize handle.
 */
export default function ConfigSectionSidebarEdge({ collapsed, onToggle }) {
  const tip = collapsed ? 'Abrir barra lateral' : 'Recolher barra lateral';
  const anchorRef = useRef(null);
  const [anchorRect, setAnchorRect] = useState(null);

  const show = useCallback(() => {
    if (!anchorRef.current) return;
    setAnchorRect(anchorRef.current.getBoundingClientRect());
  }, []);
  const hide = useCallback(() => setAnchorRect(null), []);

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        className={`process-sidebar-edge-toggle${collapsed ? ' is-collapsed' : ''}`}
        onClick={onToggle}
        aria-label={tip}
        aria-expanded={!collapsed}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      />
      <TipPortal anchorRect={anchorRect} text={tip} />
    </>
  );
}
